@if (questions() && questions().length > 0) {
  <h2 class="text-2xl font-bold mb-5 text-grey-0">Frågor och svar</h2>

  <div class="flex flex-col gap-8">

    <div class="flex flex-col gap-8">
      @for (question of questions(); track question.id) {
        <div
          appAfterRender
          class="flex flex-col gap-3">
          <div class="flex flex-col justify-start">
            <div class="text-sm text-grey-1 text-left">Fråga ställd {{ question.dateCreated }}</div>
          </div>
          <div class="text-grey-0 text-base flex flex-col gap-2">
            <div>{{ question.question }}</div>
            <div class="text-base pl-4">
              <div class="text-grey-0">
                <div class="font-bold inline">{{ careproviderUnitName() }}</div>
                svarar:
              </div>
              <div class="text-base text-grey-2 italic">
                {{ question.answer }}
              </div>
            </div>
          </div>
        </div>
      }
    </div>

    @if (showMoreBtn()) {
      <app-ui-button (click)="moreClick()"
                  [color]="'outline-tertiary'"
                  [expanded]="'block'"
                  [size]="'md'">
        Fler frågor och svar
      </app-ui-button>
    }
  </div>
}
